import { Injectable } from '@angular/core'
import { select, Store } from '@ngrx/store'
import {
  MissingTranslationHandler as NgxMissingTranslationHandler,
  MissingTranslationHandlerParams,
} from '@ngx-translate/core'
import { Observable } from 'rxjs'
import { filter, map } from 'rxjs/operators'
import { translation } from './store/i18n.interface'
import { getDefaultTranslationsState } from './store/i18n.selector'

@Injectable()
export class MissingTranslationHandlerService
  implements NgxMissingTranslationHandler
{
  private defaultTranslations: translation

  constructor(private store: Store<Observable<any>>) {
    this.store
      .pipe(
        select(getDefaultTranslationsState),
        filter((state) => Boolean(state)),
        map((state) => state.toJS()),
      )
      .subscribe((translations) => {
        this.defaultTranslations = translations
      })
  }

  handle(params: MissingTranslationHandlerParams) {
    const defaultValue = (params.interpolateParams as any)?.defaultValue

    return this.defaultTranslations
      ? defaultValue || this.defaultTranslations[params.key]
      : params.key
  }
}
